import {
  useOrderedQueryResults as useCoreOrderedQueryResults,
  UseOrderedProps,
} from '@hooks/use-ordered-query-results';

import { useUserOption } from 'features/authentication';
import { UserOptions } from 'types/authentication';

export const useOrderedQueryResults = (
  props: Omit<UseOrderedProps<UserOptions>, 'useUserOptionHook' | 'comparerProp'>
) =>
  useCoreOrderedQueryResults<UserOptions>({
    ...props,
    useUserOptionHook: useUserOption,
    comparerProp: 'id',
  });
